import {
  UPDATE_SELLER,
  RESET_SELLER
} from "./actionTypes"

export const update_seller = seller => {
  return {
    type: UPDATE_SELLER,
    payload: seller,
  }
}

export const reset_seller = () => {
  console.log('sosokso')
  return {
    type: RESET_SELLER,
  }
}
